<template>
    <div class="payment-success-container">
        <div class="success-animation">
            <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
            </svg>
        </div>
        <p class="success-message">{{ successMessage }}</p>
        <div class="actions">
            <router-link :to="listRoute" class="button">返回列表</router-link>
            <router-link :to="continueRoute" class="button secondary">继续申请</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PaymentSuccess',
        data() {
            return {
                category: null // 1=收款, 2=付款, 3=发票
            }
        },
        computed: {
            successMessage() {
                if (this.category === 1) {
                    return '收款申请提交成功！';
                } else if (this.category === 3) {
                    return '发票申请提交成功！';
                } else {
                    return '付款申请提交成功！';
                }
            },
            listRoute() {
                if (this.category === 1) {
                    return '/collection_list'; // 收款返回收款列表
                } else if (this.category === 3) {
                    return '/tax_list'; // 发票返回发票列表
                } else {
                    return '/pay'; // 付款返回付款列表
                }
            },
            continueRoute() {
                if (this.category === 1) {
                    return '/new_collection'; // 收款继续申请
                } else if (this.category === 3) {
                    return '/new_tax'; // 发票继续申请
                } else {
                    return '/new_payment'; // 付款继续申请
                }
            }
        },
        mounted() {
            // 从URL参数获取类型
            this.category = this.$route.query.category ? parseInt(this.$route.query.category) : 2;
        }
    };
</script>

<style scoped>
    .payment-success-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100vh;
        text-align: center;
        background-color: #f8f8f8;
    }

    .success-message {
        font-size: 24px;
        color: #333;
        margin-top: 20px;
    }

    .actions {
        margin-top: 30px;
    }

    .button {
        display: inline-block;
        padding: 10px 20px;
        margin: 0 10px;
        border-radius: 5px;
        text-decoration: none;
        color: white;
        background-color: #42b983;
        transition: background-color 0.3s;
        font-size: 16px;
    }

    .button:hover {
        background-color: #36a574;
    }

    .button.secondary {
        background-color: #f0f0f0;
        color: #333;
        border: 1px solid #ccc;
    }

    .button.secondary:hover {
        background-color: #e0e0e0;
    }

    /* Animation styles */
    .checkmark__circle {
        stroke-dasharray: 166;
        stroke-dashoffset: 166;
        stroke-width: 2;
        stroke-miterlimit: 10;
        stroke: #42b983;
        fill: none;
        animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
    }

    .checkmark {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        display: block;
        stroke-width: 2;
        stroke: #fff;
        stroke-miterlimit: 10;
        margin: 10% auto;
        box-shadow: inset 0px 0px 0px #42b983;
        animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
    }

    .checkmark__check {
        transform-origin: 50% 50%;
        stroke-dasharray: 48;
        stroke-dashoffset: 48;
        animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
    }

    @keyframes stroke {
        100% {
            stroke-dashoffset: 0;
        }
    }

    @keyframes scale {
        0%, 100% {
            transform: none;
        }
        50% {
            transform: scale3d(1.1, 1.1, 1);
        }
    }

    @keyframes fill {
        100% {
            box-shadow: inset 0px 0px 0px 50px #42b983;
        }
    }
</style>
